<div class="container-fluid">
  <form [formGroup]="getCentroUserReportFormGroup()">
    <div class="row paddingContainer">
      <div class="col-md-6">
        <fieldset>
          <legend style="display: inline">
            Introducción de Datos
            <mat-icon
              class="info"
              matSuffix
              [matTooltip]="
                this.translate.instant(
                  'centro.centroData.tooltipUsuariosReporteSostenibilidad'
                )
              "
              >info</mat-icon
            >
          </legend>
          <div class="dataBlock">
            <div class="profile-container">
              <img
                #photoEmReporte
                class="img-responsive profile-image"
                alt="img reporte"
                [src]="fotophotoEmReporte"
              />
              <div class="profile-content">
                <mat-form-field class="example-full-width">
                  <mat-label
                    >{{ "centro.centroData.generalInputs" | translate }}
                  </mat-label>
                  <mat-icon
                    class="info"
                    matSuffix
                    [matTooltip]="
                      this.translate.instant(
                        'centro.centroData.tooltipIntroductorDatos'
                      )
                    "
                    >info</mat-icon
                  >
                  <input
                    type="text"
                    [placeholder]="'shared.refineSearch' | translate"
                    aria-label="Número"
                    matInput
                    class="dataInput"
                    [formControl]="this.parent.responsableReporteControl"
                    [matAutocomplete]="autoReporte"
                    #nombreReporteInput
                    (change)="this.parent.onChangeUsersAutocomplete($event)"
                    [readonly]="
                      !this.centro.edicionCentro && !this.parent.isCreating
                    "
                  />
                  <cdk-virtual-scroll-viewport
                    class="autocomplete-test-viewport"
                    itemSize="50"
                    minBufferPx="500"
                    maxBufferPx="750"
                  >
                    <mat-autocomplete
                      #autoReporte="matAutocomplete"
                      [displayWith]="this.parent.displayFn"
                      (optionSelected)="
                        this.parent.onOptionSelectedReporte($event)
                      "
                    >
                      <mat-option
                        *cdkVirtualFor="
                          let option of this.parent.employeesfilterReporte
                            | async
                        "
                        [value]="option"
                      >
                        {{ option.nombre }}
                      </mat-option>
                    </mat-autocomplete>
                  </cdk-virtual-scroll-viewport>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="dataBlock">
            <div class="profile-container">
              <img
                #photoEmAmbiental
                [src]="this.fotophotoEmAmbiental"
                class="img-responsive profile-image"
                alt=""
              />
              <div class="profile-content">
                <mat-form-field class="example-full-width">
                  <mat-label>{{
                    "centro.centroData.generalInputs2" | translate
                  }}</mat-label>
                  <input
                    type="text"
                    [placeholder]="'shared.refineSearch' | translate"
                    aria-label="Número"
                    matInput
                    class="dataInput"
                    [formControl]="this.parent.introductorAmbientalControl"
                    [matAutocomplete]="autoAmbiental"
                    #nombreAmbientalInput
                    (change)="this.parent.onChangeUsersAutocomplete($event)"
                    [readonly]="
                      !this.centro.edicionCentro && !this.parent.isCreating
                    "
                  />
                  <cdk-virtual-scroll-viewport
                    class="autocomplete-test-viewport"
                    itemSize="50"
                    minBufferPx="500"
                    maxBufferPx="750"
                  >
                    <mat-autocomplete
                      #autoAmbiental="matAutocomplete"
                      [displayWith]="this.parent.displayFn"
                      (optionSelected)="
                        this.parent.onOptionSelectedAmbiental($event)
                      "
                    >
                      <mat-option
                        *cdkVirtualFor="
                          let option of this.parent.employeesfilterAmbiental
                            | async
                        "
                        [value]="option"
                      >
                        {{ option.nombre }}
                      </mat-option>
                    </mat-autocomplete>
                  </cdk-virtual-scroll-viewport>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="dataBlock">
            <div class="profile-container">
              <img
                #photoEmSocial
                [src]="this.fotophotoEmSocial"
                class="img-responsive profile-image"
                alt=""
              />
              <div class="profile-content">
                <mat-form-field class="example-full-width">
                  <mat-label>{{
                    "centro.centroData.socialInput" | translate
                  }}</mat-label>
                  <mat-icon
                    class="info"
                    matSuffix
                    [matTooltip]="
                      this.translate.instant(
                        'centro.centroData.tooltipIntroductorDatosSocial'
                      )
                    "
                    >info</mat-icon
                  >
                  <input
                    type="text"
                    [placeholder]="'shared.refineSearch' | translate"
                    aria-label="Número"
                    matInput
                    class="dataInput"
                    [formControl]="this.parent.introductorSocialControl"
                    [matAutocomplete]="autoSocial"
                    #nombreSocialInput
                    (change)="this.parent.onChangeUsersAutocomplete($event)"
                    [readonly]="
                      !this.centro.edicionCentro && !this.parent.isCreating
                    "
                  />
                  <cdk-virtual-scroll-viewport
                    class="autocomplete-test-viewport"
                    itemSize="50"
                    minBufferPx="500"
                    maxBufferPx="750"
                  >
                    <mat-autocomplete
                      #autoSocial="matAutocomplete"
                      [displayWith]="this.parent.displayFn"
                      (optionSelected)="
                        this.parent.onOptionSelectedSocial($event)
                      "
                    >
                      <mat-option
                        *cdkVirtualFor="
                          let option of this.parent.employeesfilterSocial
                            | async
                        "
                        [value]="option"
                      >
                        {{ option.nombre }}
                      </mat-option>
                    </mat-autocomplete>
                  </cdk-virtual-scroll-viewport>
                </mat-form-field>
              </div>
            </div>
          </div>
        </fieldset>
      </div>

      <div class="col-md-6">
        <fieldset>
          <legend>
            Validación de Datos
            <mat-icon
              class="info"
              matSuffix
              [matTooltip]="
                this.translate.instant(
                  'centro.centroData.tooltipValidacionDatos'
                )
              "
              >info</mat-icon
            >
          </legend>
          <div class="dataBlock">
            <div class="profile-container">
              <img
                #photoEmValPrincipal
                [src]="this.fotophotoEmValPrincipal"
                class="img-responsive profile-image"
                alt=""
              />
              <div class="profile-content">
                <mat-form-field class="example-full-width">
                  <mat-label>{{
                    "centro.centroData.mainValidator" | translate
                  }}</mat-label>
                  <input
                    type="text"
                    [placeholder]="'shared.refineSearch' | translate"
                    aria-label="Número"
                    matInput
                    class="dataInput"
                    [formControl]="this.parent.validadorPrincipalControl"
                    [matAutocomplete]="autoValPrincipal"
                    #nombreValPrincipalInput
                    (change)="this.parent.onChangeUsersAutocomplete($event)"
                    [readonly]="
                      !this.centro.edicionCentro && !this.parent.isCreating
                    "
                  />
                  <cdk-virtual-scroll-viewport
                    class="autocomplete-test-viewport"
                    itemSize="50"
                    minBufferPx="500"
                    maxBufferPx="750"
                  >
                    <mat-autocomplete
                      #autoValPrincipal="matAutocomplete"
                      [displayWith]="this.parent.displayFn"
                      (optionSelected)="
                        this.parent.onOptionSelectedValPrincipal($event)
                      "
                    >
                      <mat-option
                        *cdkVirtualFor="
                          let option of this.parent.employeesfilterValPrincipal
                            | async
                        "
                        [value]="option"
                      >
                        {{ option.nombre }}
                      </mat-option>
                    </mat-autocomplete>
                  </cdk-virtual-scroll-viewport>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="dataBlock">
            <div class="profile-container">
              <img
                #photoEmValApoyo
                [src]="this.fotophotoEmValApoyo"
                class="img-responsive profile-image"
                alt=""
              />
              <div class="profile-content">
                <mat-form-field class="example-full-width">
                  <mat-label>{{
                    "centro.centroData.supportValidator" | translate
                  }}</mat-label>
                  <input
                    type="text"
                    [placeholder]="'shared.refineSearch' | translate"
                    aria-label="Número"
                    matInput
                    class="dataInput"
                    [formControl]="this.parent.validadorApoyoControl"
                    [matAutocomplete]="autoValApoyo"
                    #nombreValSupportInput
                    (change)="this.parent.onChangeUsersAutocomplete($event)"
                    [readonly]="
                      !this.centro.edicionCentro && !this.parent.isCreating
                    "
                  />
                  <cdk-virtual-scroll-viewport
                    class="autocomplete-test-viewport"
                    itemSize="50"
                    minBufferPx="500"
                    maxBufferPx="750"
                  >
                    <mat-autocomplete
                      #autoValApoyo="matAutocomplete"
                      [displayWith]="this.parent.displayFn"
                      (optionSelected)="
                        this.parent.onOptionSelectedValApoyo($event)
                      "
                    >
                      <mat-option
                        *cdkVirtualFor="
                          let option of this.parent.employeesfilterValApoyo
                            | async
                        "
                        [value]="option"
                      >
                        {{ option.nombre }}
                      </mat-option>
                    </mat-autocomplete>
                  </cdk-virtual-scroll-viewport>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div>
            <input
              type="hidden"
              formControlName="fechaValidacion"
              [value]="this.centro.fechaValidacion"
            />
          </div>
        </fieldset>
      </div>
    </div>
  </form>
</div>
